<template>
  <div>
    <el-form-item label="经验值">
      <el-input v-model="exp"></el-input>
    </el-form-item>
    <el-form-item label="元宝">
      <el-input v-model="coin"></el-input>
    </el-form-item>
    <el-form-item label="元宝系数">
      <el-input v-model="coinx"></el-input>
    </el-form-item>
    <el-form-item label="生成的词汇">
      <el-select v-model="entity_ids" class="w100" allow-create filterable clearable multiple>
        <el-option v-for="item in currentWords" :key="item.id" :label="`${item.entity_id} ${item.word_entity.text}`"
                   :value="item.entity_id">
          {{ item.entity_id }} {{ item.word_entity.text }}
        </el-option>
      </el-select>
      <div class="text-info" style="line-height: 1.5;">
        随机从这里抓取2-5个词组成配对题
      </div>
    </el-form-item>
    <el-form-item label="限制题型">
      <el-checkbox-group v-model="enabledTypes" style="line-height: 2;">
        <el-checkbox v-for="(item, key) in allowSelectTypes" :key="key" :label="item.id">
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <div class="text-info" style="line-height: 1.5;">
        生成题目时优先使用这里选中的题型，如果为空则从所有词汇配对题型中随机生成，此配置只在当前课程内有效
      </div>
    </el-form-item>
  </div>
</template>

<script>
import _ from 'lodash';
import {pdtTypeList} from "@/components/word/util.js";

export default {
  name: "iq_words_form",
  props: {
    form: Object
  },
  data() {
    return {
      exp: 0,
      coin: 0,
      coinx: 0,
      entity_ids: [],
      enabledTypes: [],
    }
  },
  inject: [
    'getCurrentCollection'
  ],
  watch: {
    form: {
      immediate: true,
      handler(val) {
        const enabledTypes = _.get(val, 'entity_data.exercise_config.enabled_types') || '';
        this.enabledTypes = enabledTypes.split(',').filter(s => s).map(n => Number.parseInt(n));
        const entity_ids = _.get(val, 'entity_data.entity_ids') || '';
        this.entity_ids = entity_ids.split(',').map(n => Number.parseInt(n)).filter(n => n);
        this.exp = _.get(val, 'exp') || 0;
        this.coin = _.get(val, 'coin') || 0;
        this.coinx = _.get(val, 'coinx') || 0;
      }
    }
  },
  computed: {
    allowSelectTypes() {
      return pdtTypeList;
    },
    currentWords() {
      const coll = this.getCurrentCollection();
      const entities = coll ? coll.entities : [];
      return entities.filter(n => n.entity_type === 'word');
    }
  },
  methods: {
    getFormData() {
      const entity_data = _.get(this.form, 'entity_data') || {};

      if (this.enabledTypes.length) {
        _.set(entity_data, 'exercise_config.enabled_types', this.enabledTypes.join(','));
      } else {
        _.unset(entity_data, 'exercise_config.enabled_types');
        if (_.has(entity_data, 'exercise_config') && _.isEmpty(entity_data.exercise_config)) {
          delete entity_data.exercise_config;
        }
      }

      if (this.entity_ids.length) {
        entity_data.entity_ids = this.entity_ids.join(',');
      } else {
        delete entity_data.entity_ids;
      }
      const emptyData = _.isEmpty(entity_data);
      return {
        exp: this.exp,
        coin: this.coin,
        coinx: this.coinx,
        entity_id: 0,
        entity_data: emptyData ? '' : undefined,
        data: emptyData ? undefined : entity_data,
      };
    }
  }
}
</script>

<style scoped>

</style>